import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  gap: theme.spacing(0.75),
  minWidth: 0,
}));
